import { render, staticRenderFns } from "./ontick-datetime-picker.component.vue?vue&type=template&id=9d5785b6&scoped=true"
import script from "./ontick-datetime-picker.component.vue?vue&type=script&lang=js"
export * from "./ontick-datetime-picker.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-datetime-picker.component.vue?vue&type=style&index=0&id=9d5785b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5785b6",
  null
  
)

export default component.exports